export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-960-e36a9f9c52103a40ca42325c60ad42b3.webp";